import { render } from "./MainLabWorker.vue?vue&type=template&id=d31f83c0"
import script from "./MainLabWorker.vue?vue&type=script&lang=js"
export * from "./MainLabWorker.vue?vue&type=script&lang=js"

import "./MainLabWorker.vue?vue&type=style&index=0&id=d31f83c0&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__